
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'ButtonLoader',

	props: {
		large: {
			type: Boolean,
			default: false
		}
	}
})
